import { useEffect, useState } from "react";
import "./RecentOrders.css";
import API from "../../../../services/api";

import {
  MdShoppingBag,
  MdAccessTime,
  MdArrowForward,
} from "react-icons/md";

function RecentOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await API.get("/orders/provider-orders");

      setOrders(res.data.slice(0, 5));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="recent-orders-card">

      <div className="recent-header">

        <h2>Recent Orders</h2>

        <button>

          View All

          <MdArrowForward />

        </button>

      </div>

      {orders.length === 0 ? (

        <div className="no-orders">

          <MdShoppingBag />

          <p>No Orders Yet</p>

        </div>

      ) : (

        orders.map((order) => (

          <div
            className="recent-order"
            key={order._id}
          >

            <div>

              <h4>

                #{order.orderNumber || order._id.slice(-6)}

              </h4>

              <p>

                {order.customer?.name}

              </p>

            </div>

            <div>

              <span className="price">

                ₹{order.totalAmount}

              </span>

              <small>

                <MdAccessTime />

                {order.status}

              </small>

            </div>

          </div>

        ))

      )}

    </div>
  );
}

export default RecentOrders;